import InputTypes from 'utils/enums/inputTypes';
import { IField } from 'utils/interfaces/IField';

const student: IField[] = [
    {
        presentation: 'Nome',
        label: 'Nome do curso',
        name: 'name',
        type: InputTypes.text,
        columns: 3
    }
];

export default student;
